import * as React from 'react';

import { useSelector } from 'react-redux';

import { ArticleHeading4, useDeviceType } from '@cian/ui-kit';

import { getTotalCount } from '../../selectors/listing';
import { getCurrentTab } from '../../selectors/tabs';
import { getText } from './utils';

export function TotalCountTextContainer() {
  const deviceType = useDeviceType();
  const currentTab = useSelector(getCurrentTab);
  const totalCount = useSelector(getTotalCount);

  if (!totalCount) {
    return null;
  }

  const text = getText(currentTab, totalCount, deviceType);

  return <ArticleHeading4>{text}</ArticleHeading4>;
}
